import React from 'react';
import { UserProfile } from '../../types/advanced-retirement';
import FormattedInput from '../FormattedInput';

interface MyInformationSectionProps {
  userProfile: UserProfile;
  handleInputChange: (field: keyof UserProfile, value: any) => void;
}

const MyInformationSection: React.FC<MyInformationSectionProps> = ({
  userProfile,
  handleInputChange
}) => {
  return (
    <div className="form-section">
      <h3>My Information</h3>
      <div className="form-grid">
        <div className="form-group">
          <label>Age</label>
          <FormattedInput
            defaultText="45"
            value={userProfile.age}
            onChange={(value) => handleInputChange('age', value)}
            min={18}
            max={80}
            step={1}
            formatOptions={{ type: 'number', decimalPlaces: 0 }}
          />
        </div>

        <div className="form-group">
          <label>Gender</label>
          <select 
            value={userProfile.gender || 'Male'}
            onChange={(e) => handleInputChange('gender', e.target.value)}
          >
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>

        <div className="form-group">
          <label>Retirement Age</label>
          <FormattedInput
            defaultText="65"
            value={userProfile.retirementAge}
            onChange={(value) => handleInputChange('retirementAge', value)}
            min={userProfile.age || 18}
            max={85}
            step={1}
            formatOptions={{ type: 'number', decimalPlaces: 0 }}
          />
        </div>

        <div className="form-group">
          <label>Life Expectancy Scenario</label>
          <select 
            value={userProfile.lifeExpectancyScenario || 'General'}
            onChange={(e) => handleInputChange('lifeExpectancyScenario', e.target.value)}
          >
            <option value="General">General</option>
            <option value="Conservative">Conservative</option>
            <option value="Optimistic">Optimistic</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default MyInformationSection; 